var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M20 23C23.3137 23 26 20.3137 26 17 26 13.6863 23.3137 11 20 11 16.6863 11 14 13.6863 14 17 14 20.3137 16.6863 23 20 23zM11 28.9998C11.9125 27.1755 13.2245 25.6607 14.8043 24.6075 16.3841 23.5544 18.176 23 20.0001 23 21.8241 23 23.616 23.5545 25.1958 24.6077 26.7756 25.6609 28.0876 27.1757 29 29", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});